import React from 'react'

import cn from 'classnames'

import styles from './Heading.module.scss'
import { HeadingProps } from './types'

const Heading: React.FC<HeadingProps> = ({
  size,
  Tag = 'h1',
  className,
  children,
  isMarginless,
  hasEllipsis,
  alignment,
  hasDataTrackingPii,
  testId,
  ...props
}) => {
  const headingClassNames = cn(
    styles.heading,
    size && styles[`heading_${size}`],
    isMarginless && styles.marginless,
    hasEllipsis && styles.ellipsis,
    alignment && styles[alignment],
    className,
  )

  return (
    <Tag
      className={headingClassNames}
      data-tracking-pii={hasDataTrackingPii}
      data-testid={testId}
      {...props}
    >
      {children}
    </Tag>
  )
}

export default Heading
